import axios from 'axios';
import Vue from '@/main';
import config from '@/config'
import Cookies from 'js-cookie'
import store from '../store'
import router from '../router';

// 创建axios实例
const service = axios.create({
  baseURL: config.httpBaseUrl, // api的base_url
  timeout: 500000 // 请求超时时间
});

// request拦截器
service.interceptors.request.use(config => {
  // Do something before request is sent
  let token = Cookies.get('Admin-Token')
  if (token) {
    //token = 'bearer' + ' ' + token.replace(/'|"/g, '') // 把token加入到默认请求参数中
    config.headers.Authorization = token;
  }
  return config;
}, error => {
  // Do something with request error
  console.log(error); // for debug
  Promise.reject(error);
})

// respone拦截器
service.interceptors.response.use(
  response => {
    if (response.data.code === '10006') {
      Cookies.remove('Admin-Token') // 删除已经失效或过期的token（不删除也可以，因为登录后覆盖）
      store.commit('SET_LOGIN_POP_STATE', true) // 登录弹窗显示
      store.commit('SET_TOKEN', '')
      router.replace({
        path: '/index'
      })
      //router.go(0)
      Vue.$message.warning(Vue.$t('userCenter.update'));
    } else if (response.data.token) { // 判断token是否存在，如果存在说明需要更新token
      Cookies.set('Admin-Token', response.data.token) // 覆盖原来的token(默认一天刷新一次)
      store.commit('SET_TOKEN', response.data.token)
    }
    return response
  },
  error => {
    Vue.$notify.error({
      title: Vue.$t('userCenter.errorText'),
      message: error.message
    });
    return Promise.reject(error);
  }
)

export default service;



// WEBPACK FOOTER //
// ./src/utils/fetch.js